/** INFORMACJE O FIRMIE => FAKTUROMANIA */
export const FAKTUROMANIA_APP_COMPANY_NAME: string = 'Fakturomania sp. z o.o.';
export const FAKTUROMANIA_APP_COMPANY_STREET_SHORT: string = 'Okulickiego 19B / 11';
export const FAKTUROMANIA_APP_COMPANY_STREET_FULL: string = 'ul. Okulickiego 19B lok. 11';
export const FAKTUROMANIA_APP_COMPANY_POSTAL_CODE: string = '05-825';
export const FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_SHORT: string = 'Grodzisk Maz.';
export const FAKTUROMANIA_APP_COMPANY_POSTAL_CITY_FULL: string = 'Grodzisk Mazowiecki';
export const FAKTUROMANIA_APP_COMPANY_NIP: string = '529-180-26-80';
export const FAKTUROMANIA_APP_COMPANY_REGON: string = '147060749';
export const FAKTUROMANIA_APP_COMPANY_KRS: string = '0000495029';
export const FAKTUROMANIA_APP_COMPANY_REGISTRATION_AUTHORITY: string = 'Sąd Rejonowy dla m. st. Warszawy w Warszawie, XIV Wydział Gospodarczy';
export const FAKTUROMANIA_APP_COMPANY_SHARE_CAPITAL: string = '40 000 zł';
export const FAKTUROMANIA_APP_COMPANY_EMAIL: string = 'info@fakturomania.pl';
export const FAKTUROMANIA_APP_COMPANY_PHONE: string = '233 233 211';
export const FAKTUROMANIA_APP_COMPANY_WORKING_DAYS: string = 'PONIEDZIAŁEK - PIĄTEK';
export const FAKTUROMANIA_APP_COMPANY_WORKING_HOURS_START: string = '10:00';
export const FAKTUROMANIA_APP_COMPANY_WORKING_HOURS_END: string = '16:00';
export const FAKTUROMANIA_APP_COMPANY_WORKING_HOURS: string = `${FAKTUROMANIA_APP_COMPANY_WORKING_HOURS_START} - ${FAKTUROMANIA_APP_COMPANY_WORKING_HOURS_END}`;
export const FAKTUROMANIA_APP_COMPANY_VOIVODESHIP: string = 'mazowieckie';
export const FAKTUROMANIA_APP_COMPANY_WEBSITE: string = 'https://fakturomania.pl';

/** INFORMACJE O FIRMIE => BIURO RACHUNKOWE */
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_NAME: string = 'Fakturomania Biuro Rachunkowe Sp. z o.o.';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_STREET_SHORT: string = 'Okulickiego 19B / 11';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_STREET_FULL: string = 'ul. Okulickiego 19B lok. 11';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_POSTAL_CODE: string = '05-825';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_POSTAL_CITY_SHORT: string = 'Grodzisk Maz.';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_POSTAL_CITY_FULL: string = 'Grodzisk Mazowiecki';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_NIP: string = '529-181-96-92';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_REGON: string = '368812780';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_KRS: string = '0000705496';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_REGISTRATION_AUTHORITY: string = 'Sąd Rejonowy dla m. st. Warszawy w Warszawie, XIV Wydział Gospodarczy';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_EMAIL: string = 'biuro@fakturomania.pl';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_PHONE: string = '233 233 211';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_WORKING_DAYS: string = 'PONIEDZIAŁEK - PIĄTEK';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_WORKING_HOURS: string = FAKTUROMANIA_APP_COMPANY_WORKING_HOURS;
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_VOIVODESHIP: string = 'mazowieckie';
export const FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_WEBSITE: string = 'https://fakturomania.pl/biuro-rachunkowe';

export const FAKTUROMANIA_CURRENT_YEAR: number = new Date().getFullYear();
export const FAKTUROMANIA_START_YEAR: number = 2014;
export const FAKTUROMANIA_YEARS_ON_MARET: number = FAKTUROMANIA_CURRENT_YEAR - FAKTUROMANIA_START_YEAR;

/** DOWODY DO PASKA NA STRONIE GŁÓWNEJ => NIE PODAJEMY LICZBY AKTYWNYCH KLIENTÓW */
export const FAKTUROMANIA_PROOF_SINCE: string = `od ${FAKTUROMANIA_START_YEAR} r.`;
export const FAKTUROMANIA_PROOF_COMPANIES: string = 'ponad 9 tys. firm';
export const FAKTUROMANIA_PROOF_GOOGLE_RATING: string = '4,9/5 w opiniach Google';


// WEBPACK FOOTER //
// ./src/constants/company-data.ts